import { useTranslation } from 'react-i18next'

import { useScreen } from '../../../../../hooks'
import { FormikField } from '../../../../Formik'
import { InputField } from '../../../../Input'
import {
  CHAT_FORM_FIELD_NAME_TITLE,
  CHAT_FORM_TITLE_FIELD_MAX_LENGTH,
} from '../../ChatForm.constants'

function TitleField() {
  const { t } = useTranslation()

  const { isMobileScreenSize } = useScreen() // TODO make same by css media instead of useScreen

  return (
    <FormikField
      hasCounter
      Component={InputField}
      borderless={!isMobileScreenSize}
      fieldComponentProps={{
        label: `${t('Chat.TitleLabelKey')}:`,
        shouldAdaptToMobileScreen: true,
      }}
      inline={isMobileScreenSize}
      maxLength={CHAT_FORM_TITLE_FIELD_MAX_LENGTH}
      name={CHAT_FORM_FIELD_NAME_TITLE}
      placeholder={t('Chat.TitlePlaceholderKey')}
    />
  )
}

export default TitleField
